import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.scss';
import PublicationCardBlockV2 from '../../../_block_components/publication_card_block_v2';
import {
  setTabOrPublicationPage,
  setLastPublicationNumber,
} from '../../../../../redux/slices/appSlice';
import { setCurrentPublication } from '../../../../../redux/slices/currentPublicationSlice';

const PublicationCardV2 = ({ publication, globalIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentTab = useSelector((state) => state.currentTab.currentTab);
  const imgs_for_filters = useSelector((state) => state.others_data.imgs_for_filters);
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (publicationData && publicationData.content) {
      try {
        const parsedContent = JSON.parse(publicationData.content);
        setContentData(parsedContent);
      } catch (error) {
        setContentData(null);
      }
    }
  }, [publicationData]);

  const handleButtonClick = () => {
    if (publicationData && currentTab) {
      let targetPath = '';
      if (currentTab.eng_name === 'main_tab') {
        targetPath = '/' + publicationData.eng_name;
      } else {
        targetPath = '/' + currentTab.eng_name + '/' + publicationData.eng_name;
      }

      // Сохраняем номер публикации перед переходом
      if (globalIndex) {
        dispatch(setLastPublicationNumber(globalIndex));
      }

      dispatch(setCurrentPublication(publicationData));
      dispatch(setTabOrPublicationPage('publication'));
      navigate(targetPath);
    }
  };

  // Получаем фильтры из publication_settings
  const filterA = React.useMemo(() => {
    if (!publication?.publication_settings) return null;

    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_a || null;
    } catch (error) {
      return null;
    }
  }, [publication?.publication_settings]);

  const filterB = React.useMemo(() => {
    if (!publication?.publication_settings) return null;

    try {
      const settings = JSON.parse(publication.publication_settings);
      return settings.publication_filter_b || null;
    } catch (error) {
      return null;
    }
  }, [publication?.publication_settings]);

  // Рендерим только блок с индексом [0]
  const firstBlock =
    contentData && Array.isArray(contentData) && contentData.length > 0 ? contentData[0] : null;

  return (
    <div className={styles.publicationCardV2}>
      {filterB && filterB !== 'все' && (
        <div className={styles.filterBDisplay}>
          {Array.isArray(filterB) ? filterB.join(', ') : String(filterB)}
        </div>
      )}

      {firstBlock ? (
        <PublicationCardBlockV2
          blockData={firstBlock}
          path_to_folder={'https://' + publicationData?.path + publicationData.eng_name + '/'}
          onDetailsClick={handleButtonClick}
          filterA={filterA}
          filterB={filterB}
          globalIndex={globalIndex}
          imgs_for_filters={imgs_for_filters}
        />
      ) : (
        <div className={styles.noBlocksMessage}>Блоки не найдены</div>
      )}
    </div>
  );
};

export default PublicationCardV2;
